/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { DeploymentUnitOutlined } from '@ant-design/icons';

export function NodeIcon() {
  return <DeploymentUnitOutlined />;
}
